// extracted by mini-css-extract-plugin
export var contrastLow = "_1w-1";
export var externalLink = "_1w-2";
export var externalLinkIcon = "_1w-3";
export var link = "_1w-0";
export var linkLabel = "_1w-4";